import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes'
import { createNavigationGuard } from './navigation-guard'

import analyticsService from './../services/analytics-service'

const router = createRouter({
    routes,
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) return { el: to.hash }
        // 'instant': html { scroll-behavior: smooth } reaches the window scroll at every tier,
        // and a route change should land, not glide.
        if (savedPosition) return { ...savedPosition, behavior: 'instant' }
        else return { left: 0, top: 0, behavior: 'instant' }
    },
})

router.beforeEach(createNavigationGuard())

// Router 4 runs afterEach for failed navigations as well, handing the failure in
// as the third argument — Router 3 simply did not reach it. Without this test
// /logout, which aborts on purpose, would log a page view for a page nobody sees.
// A guard redirect is not a failure: it fires once, for the final destination.
router.afterEach((to, from, failure) => {
    if (failure) return
    analyticsService.trackPageView()
})

export default router
